module.exports = __webpack_public_path__ + "img/knockout.bb0f9d01.png";